<template>
  <el-popover placement="bottom-start" v-model="searchVisible">
    <el-form :model="fitter" ref="clueSearchForm" label-width="100px">
      <el-form-item label="企业状态" prop="register_status.key">
        <el-select v-model="fitter.register_status.key" @click.native="loadBaseKeys('登记状态')" :loading="isLoadingSta" multiple clearable placeholder="请选择" size="mini">
          <el-option
            v-for="item in registerTypes"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
        <upload-task-view-refresh  view-type="登记状态"/>
      </el-form-item>
      <el-form-item label="成立日期" prop="create_year.key">
        <el-date-picker
          v-model="fitter.create_year.key"
          type="year"
          size="mini"
          value-format="yyyy"
          placeholder="选择年">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="所属区域" prop="region.key">
        <el-cascader
          v-model="fitter.region.key"
          clearable
          filterable
          placeholder="请选择区域"
          collapse-tags
          :show-all-levels="false"
          :props="props"
          :options="cities"
          size="mini">
        </el-cascader>
      </el-form-item>
      <el-form-item label="手机号" prop="phone.key">
        <el-radio-group v-model="fitter.phone.key" size="mini">
          <el-radio label="1" border>有</el-radio>
          <el-radio label="2" border>无</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="渠道手机号" prop="xlb_phone.key">
        <el-radio-group v-model="fitter.xlb_phone.key" size="mini">
          <el-radio label="1" border>有</el-radio>
          <el-radio label="2" border>无</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="清洗手机号" prop="self_phone.key">
        <el-radio-group v-model="fitter.self_phone.key" size="mini">
          <el-radio label="1" border>有</el-radio>
          <el-radio label="2" border>无</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="是否微信" prop="is_wechat.key">
        <el-radio-group v-model="fitter.is_wechat.key" size="mini">
          <el-radio label="1" border>是</el-radio>
          <el-radio label="2" border>否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="是否会员" prop="user_id.key">
        <el-radio-group v-model="fitter.user_id.key" size="mini">
          <el-radio label="1" border>是</el-radio>
          <el-radio label="2" border>否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="是否订单" prop="order_id.key">
        <el-radio-group v-model="fitter.order_id.key" size="mini">
          <el-radio label="1" border>是</el-radio>
          <el-radio label="2" border>否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="服务过企业" prop="is_business.key">
        <el-radio-group v-model="fitter.is_business.key" size="mini">
          <el-radio label="1" border>是</el-radio>
          <el-radio label="2" border>否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button @click="handelClearSearch('clueSearchForm')" size="mini">重置</el-button>
        <el-button type="primary" @click="submitForm('clueSearchForm')" size="mini">查询</el-button>
      </el-form-item>
    </el-form>
    <el-button slot="reference" size="mini">线索信息筛选</el-button>
  </el-popover>
</template>

<script>
import UploadTaskViewRefresh from "../../intellectual_property/common/UploadTaskViewRefresh.vue";
export default {
  name: 'CompanyClueFitter',
  components: { UploadTaskViewRefresh },
  props: {
    fitter: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      searchLoading: false,
      searchVisible: false,
      registerTypes: [],
      isLoadingSta: false,
      provinces: [],
      isLoadProvinces: false,
      cities: [],
      isLoadCities: false,
      regions: [],
      isLoadRegions: false,
      props: { multiple: true, emitPath: false }
    }
  },
  methods: {
    handelClearSearch (formName) {
      this.$refs[formName].resetFields()
      this.searchVisible = false
      this.$emit('search', false)
    },
    submitForm(formName) {
      this.searchVisible = false
      this.$emit('search', false)
    },
    resetForm (formName) {
    },
    loadBaseKeys (key) {
      if (key === '登记状态') this.isLoadingSta = true
      if (key === '所属省份') this.isLoadProvinces = true
      if (key === '所属城市') this.isLoadCities = true
      if (key === '所属区县') this.isLoadRegions = true
      this.$axios.get('/api/admin/upload_tasks_info/keys?select_key=基本信息&key=' + key, { loadingClose: true })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            if (key === '登记状态') {
              this.registerTypes = data.data
              this.isLoadingSta = false
            } else if (key === '所属省份') {
              this.provinces = data.data
              this.isLoadProvinces = false
            } else if (key === '所属城市') {
              this.cities = data.data
              this.isLoadCities = false
            } else if (key === '所属区县') {
              this.regions = data.data
              this.isLoadRegions = false
            }
          }
        })
    },
    getCityData () {
      this.$axios.get('/api/admin/upload_task_info/cities', { loadingClose: true })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.cities = data.data
          }
        })
    },
    cityChange () {}
  },
  mounted() {
    this.getCityData()
  }
}
</script>

<style lang="stylus" scoped>
.el-form-item {
  margin: 0;
}
.el-cascader {
  width: 100%;
}
.el-cascader >>> .el-input--mini .el-input__inner {
  height: 28px !important;
}
.el-cascader >>> .el-cascader__tags {
  top: 55%;
}
</style>



// WEBPACK FOOTER //
// src/pages/company_risks/common/CompanyClueFitter.vue